import type { ModulePermissionAction, PermissionsMap, User } from './AuthContext';

export function canAccessModule(
  user: User | null,
  permissions: PermissionsMap,
  moduleKey: string,
  action: ModulePermissionAction,
): boolean {
  if (!user) return false;
  if (user.role === 'ADMIN') return true;
  const p = permissions[moduleKey];
  if (!p) return false;
  switch (action) {
    case 'view':
      return p.canView;
    case 'edit':
      return p.canEdit;
    case 'delete':
      return p.canDelete;
    default:
      return false;
  }
}
